import React, { useState,useEffect } from 'react';
import firebase from "firebase/app";
import { useHistory } from 'react-router-dom';
import { Button, TextField, Container, Typography, Card, CardContent } from '@material-ui/core';
import logo from './../rcrm_logo.png'; // Adjust the path to your logo if needed
import "./formvalid.css"; // Assuming this contains any global styles
import swal from 'sweetalert';
import moment from 'moment';
const Formvalid = () => {
  if (document.addEventListener) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    }, false);
  }
  const history = useHistory();

  const [formvalid, setFormvalid] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); // For button loading state

  const onChangeformvalid = (e) => {
    setFormvalid(e.target.value);
  };

  const [loading, setLoading] = useState(true); // To handle the initial loading state
  // useEffect(() => {
  //   if(process.env.REACT_APP_LOAD_TESTING == 1){
  //     setLoading(false);
  //   }else{
  //     const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
  //       if (!user) {
  //         setLoading(false);
  //         history.push('/login');
  //       }
  //       return () => unsubscribe();
  //   });
  //   }
  // }, [history]);

  const handleClickformvalid = async () => {
    // Prevent multiple submissions
    if (isSubmitting) {
      return;
    }
    
    setIsSubmitting(true);
    
    // Just track the current user for timer validation (don't clear sessionStorage)
    const currentUserEmail = sessionStorage.getItem("checkemail") || localStorage.getItem("userEmail");
    const storedUserEmail = sessionStorage.getItem("timer_user_email");
    
    // Only set user email if not already set
    if (!storedUserEmail) {
      console.log("🆕 NEW USER IN FORMVALID: Setting timer user email");
      sessionStorage.setItem("timer_user_email", currentUserEmail);
    }
    
    // Check if we're in load testing mode
    const isLoadTesting = (typeof process !== 'undefined' && process && process.env && process.env.REACT_APP_LOAD_TESTING === '1');
    
    if (isLoadTesting) {
      // For load testing, bypass all restrictions but still get timer from Firebase
      if (!formvalid.trim()) {
        setIsSubmitting(false);
        swal("Assessment Code Required", "Enter an assessment code to proceed.", "error");
        return;
      }
      
      // Store exam code
      sessionStorage.setItem("formvalid", formvalid);
      sessionStorage.setItem("exam_timer", "60"); // Default timer for load testing
      sessionStorage.setItem("form_link", ""); // Empty form link for load testing
      
      // Skip fullscreen and go directly to exam screen
      // history.push("/examscreen");
      history.push(`/dynamic-exam/${formvalid}`);
      return;
    }
    
    // Regular flow for non-load testing
    // Check authentication first and ensure token is available
    const currentUser = firebase.auth().currentUser;
    
    if (!currentUser && !isLoadTesting) {
      setIsSubmitting(false);
      swal("Authentication Required", "Authentication is required before accessing the assessment.", "error");
      history.push("/login");
      return;
    }

    // Ensure user has a valid token before accessing Firebase
    if (currentUser && !isLoadTesting) {
      try {
        await currentUser.getIdToken(true); // Force token refresh
      } catch (tokenError) {
        setIsSubmitting(false);
        swal("Authentication Error", "Authentication session expired. Please login again to continue.", "error");
        history.push("/login");
        return;
      }
    }
    
    // Sanitize the email
    const sanitizeEmail = (email) => {
      if (!email) return '';
      return email.replace(/\./g, ','); // Replace '.' with ','
    };
  
    // Check for email in both sessionStorage and localStorage (for load testing)
    const email = sessionStorage.getItem("checkemail") || localStorage.getItem("userEmail");
    
    if (!email) {
      setIsSubmitting(false);
      swal("Authentication Required", "Authentication is required before accessing the assessment.", "error");
      return;
    }
    
    const sanitizedEmail = sanitizeEmail(email);
    const examDataTable = (typeof process !== 'undefined' && process && process.env && process.env.REACT_APP_MANUAL_QUESTION_PAPER == 1) ? "TestPapers" : 'Exams_data';
    
    // First, check if the user has already taken the exam
    const examRecordRef = firebase.database().ref(`Exam_results/${formvalid}/${sanitizedEmail}`);
    
    examRecordRef.once('value').then((snapshot) => {
      if (snapshot.exists()) {
        setIsSubmitting(false);
        swal("Assessment Already Completed", "You have already completed this assessment.", "error");
              } else {
          // If the user has not taken the exam, proceed to get the form link and timer
          const con_db = firebase.database().ref(examDataTable);
          
          con_db.once('value', (snapshot) => {
          const s = snapshot.val();
          const d = s[formvalid];
  
          if (d != null) {
            const form_link = d["formlink"];
            const exam_timer = d["examTimer"] || d["timer"]; // Handle both old and new field names
            const currentEpochTime = moment().valueOf();
            const currentEpochTimeInSeconds = Math.floor(currentEpochTime / 1000);
            
            // Handle both old and new date formats
            let exam_start_time, exam_end_time;
            
            if (d['isDynamic'] === true || d['dynamic'] === true) {
              // New dynamic exam format
              exam_start_time = (d["startDate"] || d["start"]) / 1000; // Convert from milliseconds to seconds
              exam_end_time = (d["endDate"] || d["end"]) / 1000;
            } else {
              // Old format
              exam_start_time = d["startTime"];
              exam_end_time = d["endTime"];
            }

            // Save the form link and timer in sessionStorage
            if (currentEpochTimeInSeconds >= exam_start_time && currentEpochTimeInSeconds <= exam_end_time) {
              // Set timer data for current user (don't clear existing timer unnecessarily)
              sessionStorage.setItem("timer_user_email", currentUserEmail);
              sessionStorage.setItem("form_link", form_link);
              sessionStorage.setItem("exam_timer", exam_timer);
              sessionStorage.setItem("formvalid", formvalid);
              // Reset seconds to 0 for fresh start
              sessionStorage.setItem("exam_sec", "0");
              // Fresh attempt - clear any security warnings carried over from a previous assessment
              sessionStorage.removeItem("count_totalWarnings");
              sessionStorage.removeItem("exam_terminated");
              
              console.log("⏰ TIMER SET: Firebase timer value", exam_timer, "minutes");
              const elem = document.documentElement;
              
              // For load testing, skip fullscreen and go directly to exam
              if (isLoadTesting) {
                if(d['isDynamic'] === true || d['dynamic'] === true){
                  history.push(`/dynamic-exam/${formvalid}`);
                }else if(d['isPshyco'] == 2){
                  history.push("/textbasedexamscreen");
                }else{
                  history.push("/examscreen");
                }
                return;
              }
              
              // Regular flow - request fullscreen
              if (elem.requestFullscreen) {
                elem.requestFullscreen();
                if(d['isDynamic'] === true || d['dynamic'] === true){
                  history.push(`/dynamic-exam/${formvalid}`);
                }else if(d['isPshyco'] == 2){
                  history.push("/textbasedexamscreen");
                }else{
                  history.push("/examscreen");
                }
              } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
                if(d['isDynamic'] === true || d['dynamic'] === true){
                  history.push(`/dynamic-exam/${formvalid}`);
                }else if(d['isPshyco'] == 2){
                  history.push("/textbasedexamscreen");
                }else{
                  history.push("/examscreen");
                }
              } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
                if(d['isDynamic'] === true || d['dynamic'] === true){
                  history.push(`/dynamic-exam/${formvalid}`);
                }else if(d['isPshyco'] == 2){
                  history.push("/textbasedexamscreen");
                }else{
                  history.push("/examscreen");
                }
              }
            }else{
              const startDate = new Date(exam_start_time * 1000).toLocaleString();
              const endDate = new Date(exam_end_time * 1000).toLocaleString();
              setIsSubmitting(false);
              swal("Assessment Not Available", `The assessment is only available between ${startDate} and ${endDate}.`, "error");
            }
          } else {
            setIsSubmitting(false);
            swal("Invalid Assessment Code", "Enter a valid assessment code to proceed", "error");
          }
        }).catch((error) => {
          setIsSubmitting(false);
          swal("Error", "Unable to validate assessment code. Please try again.", "error");
        });
      }
    }).catch((error) => {
      setIsSubmitting(false);
      swal("Error", "Unable to verify assessment status. Please try again.", "error");
    });
  };
  

  return (
    <div className="MainDiv">
        <img src={logo} alt="logo" className="App-logo" />

      <div className="form-container">
        <h1 className="form-heading" id="enterExamCodeHeaderTxt">Enter Assessment Code</h1>
        <input 
          type="text" 
          name="inputcode" 
          id="inputcode" 
          placeholder='Enter Assessment Code'
          onChange={onChangeformvalid} 
          value={formvalid}
          style={{ padding: '10px', height:48,fontSize:20, width: '100%', marginBottom: '20px', border: '1px solid #004085', borderRadius: '5px' }} 
        />
        <div className="button-container">
          <Button 
            variant="contained" 
            className="startTest"
            onClick={handleClickformvalid} 
            disabled={isSubmitting}
            style={{ 
              backgroundColor: isSubmitting ? '#6c757d' : '#007bff', 
              color: 'white', 
              padding: '10px 20px',
              minWidth: '200px',
              position: 'relative',
              transition: 'all 0.3s ease'
            }}
          >
            {isSubmitting ? (
              <>
                <div style={{
                  display: 'inline-block',
                  width: '16px',
                  height: '16px',
                  border: '2px solid #ffffff',
                  borderTop: '2px solid transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                  marginRight: '8px'
                }}></div>
                Validating...
              </>
            ) : (
              'Begin Assessment'
            )}
          </Button>
        </div>
      </div>
    </div>
  );

}

export default Formvalid;
